export default "__VITE_ASSET__Bv5nblz5__"